

import { Pipe, PipeTransform } from '@angular/core';

import { MwcI18nService } from './mwc-i18n.service';

@Pipe({
  name: 'mwcI18n'
})
export class MwcI18nPipe implements PipeTransform {
  constructor(private _locale: MwcI18nService) {}

  transform(path: string, keyValue?: object): string {
    return this._locale.translate(path, keyValue);
  }
}
